import { UserHelpers } from "components/user";

const { permission } = UserHelpers;

const isAdmin = (role) => {
    return [ "admin", "developer" ].indexOf(role) !== -1;
}

const hasEvents = (events) => {
    return events.length >= 1;
}

const hasActiveEvent = (user) => {
    return hasEvents(user.exhibitionEvent) && isEventPermitted(user) && !!user.eeCurrentId;
}

const hasRealActiveEvent = (user) => {
    if (!user || !user.exhibitionEvent || !Array.isArray(user.exhibitionEvent) || user.exhibitionEvent.length === 0)
    {
        return false;
    }

    if (!user.eeCurrentId)
    {
        return false;
    }

    return user.exhibitionEvent.some(({ id }) => id === user.eeCurrentId);
};

const canUseAttendance = (user, eeId = user?.eeCurrentId) => {
    if (
        !user ||
        !Array.isArray(user.exhibitionEvent) ||
        user.role?.id === null ||
        user.role?.id === undefined ||
        eeId === null ||
        eeId === undefined
    ) {
        return false;
    }

    const selectedEvent = user.exhibitionEvent.find((event) => (
        event?.id !== null &&
        event?.id !== undefined &&
        String(event.id) === String(eeId)
    ));

    if (!selectedEvent || !Array.isArray(selectedEvent.relWorkerRoles)) {
        return false;
    }

    return selectedEvent.relWorkerRoles.some((role) => (
        role?.id !== null &&
        role?.id !== undefined &&
        String(role.id) === String(user.role.id)
    ));
};

const isEventPermitted = (user, eeId) => {
    if (!user || !user.exhibitionEvent)
    {
        return false;
    }

    const { exhibitionEvent: ee } = user;
    const checkEEId = eeId ? eeId : user.eeCurrentId;

    return hasEvents(ee) && ee.filter(({ id }) => id === checkEEId).length >= 1;
}

const getUserPermissions = (user) => {
    if (!user)
    {
        return {
            isLimitedUser: false,
            hasCollectGraphicsPermission: false,
            hasViewJobPermission: false,
            hasViewDamagesPermission: false,
            hasViewNotRelatedPermission: false
        };
    }

    const userPermission = permission(user);
    const hasCollectGraphicsPermission = userPermission.has({ value: "collect_graphics" });
    const hasViewJobPermission = userPermission.has({ type: "craft_job", value: "view_job" });
    const hasViewDamagesPermission = userPermission.has({ value: "view_damages" });
    const hasViewNotRelatedPermission = userPermission.has({ value: "view_not_related" });

    return {
        isLimitedUser: hasCollectGraphicsPermission && !hasViewJobPermission && !hasViewDamagesPermission,
        hasCollectGraphicsPermission,
        hasViewJobPermission,
        hasViewDamagesPermission,
        hasViewNotRelatedPermission
    };
};

const checkUser = {
    isAdmin,
    hasEvents,
    hasActiveEvent,
    hasRealActiveEvent,
    canUseAttendance,
    isEventPermitted,
    getUserPermissions
}

export default checkUser;
